/**
 * a Tooltip that shows website data
 */

import { PopupHoverContainer } from "@similarweb/ui-components";
import { WebsiteTooltipContent } from "./WebsiteTooltipContent";
import type { FunctionComponent, ReactNode } from "react";
import classNames from "classnames";

export interface IWebsiteTooltipProps {
    domain: string;
    mainDomainOnly?: boolean;
    placement?: string;
    hideTrackButton?: boolean;
    debounce?: number;
    appendTo?: string;
    handleOpenQualificationSideBar?: (e: FixmeType) => void;
    children: ReactNode;
    className?: string;
}

export const WebsiteTooltip: FunctionComponent<IWebsiteTooltipProps> = ({ placement = "top-left", ...props }) => {
    return (
        <PopupHoverContainer
            content={() => (
                <WebsiteTooltipContent
                    domain={props.domain}
                    mainDomainOnly={props.mainDomainOnly}
                    hideTrackButton={props.hideTrackButton}
                    handleOpenQualificationSideBar={props.handleOpenQualificationSideBar}
                />
            )}
            config={{
                placement,
                cssClassContent: "Popup-content-infoCard",
                cssClassContainer: classNames("Popup-Container-infoCard", props.className),
                width: props.handleOpenQualificationSideBar ? 460 : 394,
                height: 204,
                allowHover: true,
                closeDelay: 50,
            }}
            debounce={props.debounce}
            appendTo={props.appendTo}
        >
            {props.children}
        </PopupHoverContainer>
    );
};

WebsiteTooltip.displayName = "WebsiteTooltip";
